import * as yup from 'yup';
// Tokens do novo layout (docs/jogador/telas/NPS-LAYOUT-BRIEF.md). A cor da marca vem do theme, nunca daqui.
export var COR_TEXTO = '#1D1D1F';
export var COR_TEXTO_SECUNDARIO = '#6E6E73';
export var COR_PREENCHIMENTO = '#F2F2F7';
export var COR_SEPARADOR = '#E5E5EA';
export var COR_PLACEHOLDER = '#A1A1A6';
export var COR_DESABILITADO_FUNDO = '#E5E5EA';
export var COR_DESABILITADO_TEXTO = '#8E8E93';
export var COR_CONFIRMACAO = '#1F7A45';
export var COR_ESTRELA = '#F5A623';
export var COR_ERRO = '#D1363E';
export var COR_BRANCA = '#FFFFFF';
// Borda da caixa do comentário: contraste ≥ 3:1 sobre o branco, para o campo ser percebido.
export var COR_BORDA_CAMPO = '#8E8E93';
// Cores das notas: iguais para todas as empresas.
export var COR_DA_NOTA = {
    detrator: '#D1363E',
    neutro: '#A35A00',
    promotor: '#1F7A45',
};
export var FONTE_NPS = '-apple-system, BlinkMacSystemFont, "SF Pro Text", Inter, "Segoe UI", Roboto, sans-serif';
export var LIMITE_COMENTARIO = 500;
export var CONTAGEM_SEGUNDOS = 3;
export var TIMEOUT_ACESSO_GOOGLE_MS = 3000;
// Tempo depois do redirecionamento: se a página continuar em "Abrindo o Google…", segue para o Obrigado.
export var TEMPO_MAXIMO_ABRINDO_GOOGLE_MS = 8000;
export var NOTAS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export var POST_NPS_URL = 'nps';
export var PUT_NPS_URL = 'nps';
export var PATCH_NPS_URL = 'nps';
export var TERMO_USO_DADOS_URL = 'https://docs.google.com/document/d/1WwcGwRo3MKRs3BN5bsddaGdnaasmqa8QIrMiJIiisKs/edit?usp=drivesdk';
// Consentimento LGPD: frase no lugar do checkbox (D5). Se o jurídico exigir aceite explícito, basta trocar para true.
export var NPS_CONSENTIMENTO_CHECKBOX = false;
var TAMANHO_MAXIMO_NOME = 100;
var TAMANHO_MAXIMO_EMAIL = 100;
var QUANTIDADE_DIGITOS_TELEFONE = 11;
// Mesmas regras do backend (PATCH nps/{id}/contato), para o botão só habilitar com dados que serão aceitos.
export var ESQUEMA_CONTATO = yup.object({
    nome: yup
        .string()
        .trim()
        .max(TAMANHO_MAXIMO_NOME, "O nome deve ter no m\u00E1ximo " + TAMANHO_MAXIMO_NOME + " caracteres")
        .required('O nome é obrigatório'),
    email: yup
        .string()
        .email('Email inválido')
        .max(TAMANHO_MAXIMO_EMAIL, "O email deve ter no m\u00E1ximo " + TAMANHO_MAXIMO_EMAIL + " caracteres")
        .required('O email é obrigatório'),
    telefone: yup
        .string()
        .required('O telefone é obrigatório')
        .test('telefone-completo', "O telefone deve ter " + QUANTIDADE_DIGITOS_TELEFONE + " n\u00FAmeros", function (telefone) { return (telefone !== null && telefone !== void 0 ? telefone : '').replace(/\D/g, '').length === QUANTIDADE_DIGITOS_TELEFONE; }),
});
export var TEXTOS_DO_GRUPO = {
    detrator: {
        rotuloComentario: 'O que aconteceu?',
        apoioComentario: 'O que não foi legal? Conte pra gente.',
        subtituloContato: 'O responsável pela unidade fala com você',
    },
    neutro: {
        rotuloComentario: 'O que faltou para ser nota 10?',
        apoioComentario: 'O que faltou para ser nota 10?',
        subtituloContato: 'Respondemos pelo WhatsApp ou e-mail',
    },
    promotor: {
        rotuloComentario: 'Conte o que você amou',
        apoioComentario: 'O que você mais gostou?',
        subtituloContato: 'Respondemos pelo WhatsApp ou e-mail',
    },
};
export var MENSAGEM_ERRO_ENVIO = 'Não foi possível enviar sua avaliação. Tente novamente.';
export var MENSAGEM_ERRO_FOTO = 'Não foi possível anexar a foto. Tente novamente.';
export var MENSAGEM_ERRO_CONTATO = 'Não foi possível enviar seu contato. Tente novamente.';
